import React, {memo} from 'react';
import cls from './Avatar.module.css';
import {UserOutlined} from "@ant-design/icons";
import { Skeleton } from 'antd';
import {classNames} from "../../lib/classNames/classNames";
import {AppImage} from "../AppImage";

type SizeType = number | 'large' | 'small' | 'default';
interface AvatarProps {
    className?: string;
    src?: string;
    alt?: string;
    size?: SizeType;
}

export const Avatar = memo((props: AvatarProps) => {
    const { className, src, alt, size = 'default', ...otherProps } = props;
    const fallback = <Skeleton.Avatar size={size} shape={"circle"} />;

    return (
        <AppImage
            className={classNames(cls.Avatar, {}, [className])}
            src={src}
            alt={alt}
            isLoadingFallback={fallback}
            errorFallback={<UserOutlined />}
            {...otherProps}
        />
    );
});
